import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { ALL_MEETINGS } from "../queries";
import { useQuery } from "@apollo/client";
//ALL_ORGANS, ALL_COMMENTS, ALL_USERS, ALL_MINUT, ALL_MINUTES, ALL_LINKS, ALL_VOTES, ALL_INITIATIVES, ALL_MUNICIPALITIES, ALL_SECTIONS,  ORGAN_ADDED,  ALL_PROPOSALS
/* eslint-disable react/prop-types */
const Meeting = ({ selectedKunta }) => {
  const [meetings, setMeetings] = useState([]);
  const [selected, setSelected] = useState([]);
  ////console.log(setOrgans);
  const meetingssw = useQuery(ALL_MEETINGS, {
    pollInterval: 100000,
  });
  let organ = useParams().chosenorgan;
  useEffect(() => {
    let valittu = meetings.filter(function (el) {
      return el.organid === organ;
    });
    //console.log(valittu);
    setSelected(valittu);
  }, [selectedKunta, meetings]);
  useEffect(() => {
    let meetingss = [];
    //let municipalitiess = [];
    if (meetingssw.data) {
      meetingss = meetingssw.data.allMeetings;
      //setOrgans(organss);
      //console.log(meetingss);
      let meets = meetingss.filter((cont) => {
        return cont.meetingmunicipality === selectedKunta;
      });
      setMeetings(meets);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, []);
  useEffect(() => {
    let meetingss = [];
    //let municipalitiess = [];
    if (meetingssw.data) {
      meetingss = meetingssw.data.allMeetings;
      //setOrgans(organss);
      //console.log(meetingss);
      let meets = meetingss.filter((cont) => {
        return cont.meetingmunicipality === selectedKunta;
      });
      //console.log(meets);
      setMeetings(meets);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [selectedKunta, meetingssw]);
  if (selected) {
    return (
      <div>
        <br />
        <br />
        {meetings.map((p) => (
          <li key={p.id}>
            <Link to={`/agendas/${p.id}`}>{p.organid} </Link> {p.meetingtext} {p.organid}
          </li>
        ))}
      </div>
    );
  } else {
    return <li className="meeting">Ei kokouksia</li>;
  }
};

export default Meeting;
